import { z } from 'zod';
import { REVIEW_MAX_STARS, REVIEW_MIN_STARS } from '../constants.js';
import { REVIEW_STATUSES } from '../enums.js';
import { longText, paginationSchema, optionalShortText, shortText, uuid } from './common.js';

export const createReviewSchema = z.object({
  /**
   * The offer being reviewed. Requiring it means only a consumer who actually
   * accepted a quote can rate that partner — the legacy endpoint accepted a
   * bare `compid` from anyone.
   */
  offerId: uuid,
  stars: z.coerce.number().int().min(REVIEW_MIN_STARS).max(REVIEW_MAX_STARS),
  title: shortText(160),
  body: longText(4000),
  attachmentAssetIds: z.array(uuid).max(6).default([]),
});

export const moderateReviewSchema = z.object({
  status: z.enum(['APPROVED', 'REJECTED']),
  note: optionalShortText(500),
});

export const reviewListQuerySchema = paginationSchema.extend({
  status: z.enum(REVIEW_STATUSES).optional(),
  partnerId: uuid.optional(),
});

export type CreateReviewInput = z.infer<typeof createReviewSchema>;
export type ModerateReviewInput = z.infer<typeof moderateReviewSchema>;
